export default __webpack_public_path__ + "static/media/intern_fear_5.080a71c7.gif";